import React from "react";
import { makeStyles } from "@material-ui/core/styles";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Avatar from "@material-ui/core/Avatar";
import ImageIcon from "@material-ui/icons/Image";
import WorkIcon from "@material-ui/icons/Work";
import BeachAccessIcon from "@material-ui/icons/BeachAccess";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    maxWidth: 360,
    backgroundColor: theme.palette.background.paper,
  },
}));

export default function TransactionList() {
  // const classes = useStyles();

  return (
    <div className="msg-content-wrapper message-content-wrapper-bot msg-content-wrapper-border width-70 " style={{ border: "8px solid rgba(244, 176, 53, 0.8)"}}>
      <List>
        <ListItem>
          {/* <ListItemAvatar>
            <Avatar>
              <ImageIcon />
            </Avatar>
          </ListItemAvatar> */}
          <ListItemText
            primary="Fuel Allowance Reimbursement"
            secondary="Jan 9, 2014"
          />
          <ListItemText primary="Amount" secondary="3000" />
          <ListItemText primary="Current Balance" secondary="1500" />
        </ListItem>
        <ListItem>
          <ListItemAvatar>
            <Avatar>
              <ImageIcon />
            </Avatar>
          </ListItemAvatar>
          <ListItemText
            primary="Outfit Allowance Reimbursement"
            secondary="Jan 9, 2014"
          />
        </ListItem>
      </List>
    </div>
  );
}
